// extracted by mini-css-extract-plugin
module.exports = {"directusHtmlWrapper":"DirectusHtmlWrapper_directusHtmlWrapper__CKvk9"};